"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentType = void 0;
var PaymentType;
(function (PaymentType) {
    PaymentType["CBL"] = "cbl";
    PaymentType["CB"] = "cb";
    PaymentType["ESPECES"] = "especes";
    PaymentType["TR"] = "tr";
    PaymentType["TRD"] = "trd";
    PaymentType["CHEQUE"] = "cheque";
    PaymentType["HOLIDAY_CHEQUE"] = "holiday_cheque";
    PaymentType["PLATFORM"] = "platform";
    PaymentType["BILL"] = "bill";
    PaymentType["OTHER"] = "other";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
